
export default {
  props: {
    category: {
      type: Object,
      default: null
    },
    level: {
      type: Number,
      default: 0
    }
  },
  vessel: {
    title: {
      marginTop: 'md',
      marginBottom: 'sm',
      fontSize: '2xl',
      $topLevel: {
        color(val) {
          return val ? 'blue' : 'grey-darkest'
        },
        textTransform(val) {
          return val && 'uppercase'
        }
      }
    }
  },
  computed: {
    topLevel() {
      return this.level <= 1
    },
    categoryId() {
      return this.category.id || this.category.name.replace(/^\s+|\s+$/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9 -]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
    }
  }
}
